/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IGetDocumentThreadsMessage extends IMessage {
	documentId: string;
}

export default class GetDocumentThreadsMessage extends Message {
	public static readonly TYPE: string = '94';

	public static readonly READABLE_TYPE_NAME: string = 'getDocumentThreads';

	public static readonly DESCRIPTOR_NAME: string = 'CommentsV2GetDocumentThreadsMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			documentId: {
				type: 'string',
				id: 1
			}
		}
	};

	public constructor( public readonly documentId: string ) {
		super();
	}

	public toJSON(): IGetDocumentThreadsMessage {
		return {
			documentId: this.documentId
		};
	}

	public static fromJSON( object: IGetDocumentThreadsMessage ): GetDocumentThreadsMessage {
		return new GetDocumentThreadsMessage( object.documentId );
	}
}
